import { Card, CardBody, CardHeader, CardTitle, Alert } from '@/common'
import { useAppConfig } from '@/shared/hooks/api/appConfig'
import { AddAssetWithIdPayload } from '../useAssetInstances'
import { ProductionRouteAsset } from '@/features/production-routes/api/ProductionRouteModel'
import AssetCategoryEditor from '../components/AssetCategoryEditor'
import { useTranslation } from 'react-i18next'

export function ClinkerProcessEmissionsAssetEditor({
  selectedAssets,
  addAssetWithId,
  removeAssetWithId,
  updateAssetWithId,
  removeMultipleAssets,
  id
}: {
  selectedAssets: ProductionRouteAsset[]
  areAssetsUsed?: boolean
  updateAreAssetsUsed?: (value: boolean) => void
  addAssetWithId: (payload: AddAssetWithIdPayload) => void
  removeAssetWithId: (assetId: number) => void
  updateAssetWithId: (assetId: number, asset: ProductionRouteAsset) => void
  removeMultipleAssets: (ids: number[]) => void
  id: string
}) {
  const { t } = useTranslation()
  const { assetsById } = useAppConfig().config
  const assetDefinitions = [assetsById['rotary_kiln'], assetsById['shaft_kiln']]

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle title={t(`emissionPoints:clinker_process_emissions.title`)} />
        </CardHeader>
        <CardBody className="space-y-4">
          <Alert type="info" className="whitespace-pre-line">
            {t(`emissionPoints:clinker_process_emissions.callout`)}
          </Alert>
          <AssetCategoryEditor
            title={t(
              `emissionPoints:clinker_process_emissions.assetCategories.clinker_process_emissions.title`
            )}
            selectedAssets={selectedAssets}
            addAssetWithId={addAssetWithId}
            removeAssetWithId={removeAssetWithId}
            updateAssetWithId={updateAssetWithId}
            removeMultipleAssets={removeMultipleAssets}
            id={id}
            assetDefinitions={assetDefinitions}
            technologyTypeQuestion={t(
              `emissionPoints:clinker_process_emissions.assetCategories.clinker_process_emissions.technologyTypeQuestion`
            )}
          />
        </CardBody>
      </Card>
    </>
  )
}
